export const isValidEmail = (query: string): boolean => {
  const email = query.trim();
  if (!email) return false;
  return /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/.test(email);
};
